import type { FC, ComponentType } from "react";
import { HiDocumentText, HiCurrencyEuro, HiUserGroup } from "react-icons/hi";
import type { HeatmapMetric } from "../../config/heatmap-metrics";
import { METRIC_CONFIGS } from "../../config/heatmap-metrics";

export interface MetricSelectorProps {
  activeMetric: HeatmapMetric;
  onMetricChange: (metric: HeatmapMetric) => void;
  className?: string;
}

const METRIC_OPTIONS: Array<{
  id: HeatmapMetric;
  label: string;
  icon: ComponentType<{ className?: string }>;
  badge?: string;
}> = [
  {
    id: "contracts",
    label: METRIC_CONFIGS.contracts.label,
    icon: HiDocumentText,
  },
  {
    id: "commission",
    label: METRIC_CONFIGS.commission.label,
    icon: HiCurrencyEuro,
  },
  {
    id: "age",
    label: METRIC_CONFIGS.age.label,
    icon: HiUserGroup,
  },
];

export const MetricSelector: FC<MetricSelectorProps> = ({
  activeMetric,
  onMetricChange,
  className = "",
}) => {
  return (
    <div
      role="group"
      aria-label="Kartenmetrik auswählen"
      className={`inline-flex items-center rounded-xl bg-white/90 p-1 shadow-md backdrop-blur-md transition-all duration-200 dark:bg-gray-800/90 dark:border dark:border-gray-700/60 ${className}`}
    >
      {METRIC_OPTIONS.map((option) => {
        const isActive = activeMetric === option.id;
        const Icon = option.icon;
        const config = METRIC_CONFIGS[option.id];

        return (
          <button
            key={option.id}
            type="button"
            title={config.description}
            onClick={() => onMetricChange(option.id)}
            className={`relative flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50 ${
              isActive
                ? "bg-primary-600 text-white shadow-sm dark:bg-primary-500"
                : "text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-700/60 dark:hover:text-white"
            }`}
          >
            <Icon
              className={`h-4 w-4 transition-transform duration-150 ${
                isActive ? "scale-110" : ""
              }`}
            />
            <span className="whitespace-nowrap">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};
